import React from "react";
import PrivateRoutes from "./PrivateRoutes";
import Dashboard from "../dashboard/Dashboard";
import CreateCard from "../dashboard/CreateCard";
import CardsList from "../dashboard/CardsList";
import UpdateCard from "../dashboard/UpdateCard";
import Orders from "../dashboard/Orders";
function AuthenticatedRoutes() {
  return (
    <>
      <PrivateRoutes path="/dashboard" element={<Dashboard />} />
      <PrivateRoutes path="/createcard" element={<CreateCard />} />
      <PrivateRoutes path="/cardslist" element={<CardsList />} />
      <PrivateRoutes path="/updateCard/:id" element={<UpdateCard />} />
      <PrivateRoutes path="/orders" element={<Orders />} />

    </>
  );
}

export default AuthenticatedRoutes;
